// Multi-language bad-words filter (DE/EN/FR/ES/IT/PT/NL/PL/SV/DA).
// Wir filtern aggressive, hasserfüllte oder vulgäre Wörter. Liste ist bewusst
// konservativ — kein vollständiger Profanity-Filter, aber decken die häufigsten
// Insults / Hassbegriffe ab.

const BAD_WORDS_RAW = [
  // German
  "arschloch", "wichser", "fotze", "hure", "schlampe", "missgeburt", "nazi",
  "scheisse", "scheiße", "fick", "ficken", "fickt", "schwuchtel", "spasti",
  "behindert", "kanake", "neger", "drecksau", "dreckskerl", "huensohn",
  "hurensohn", "verpiss",
  // English
  "asshole", "bastard", "bitch", "bullshit", "cunt", "dick", "fuck", "fucker",
  "fucking", "motherfucker", "nigger", "nigga", "pussy", "shit", "slut",
  "twat", "whore", "faggot", "retard",
  // French
  "putain", "salope", "connard", "encule", "merde", "pute", "tapette",
  // Spanish
  "puta", "puto", "cabron", "cabrón", "mierda", "joder", "coño", "pendejo",
  "polla", "marica",
  // Italian
  "stronzo", "stronza", "puttana", "cazzo", "vaffanculo", "merda", "troia",
  "frocio",
  // Portuguese
  "porra", "caralho", "puta", "merda", "viado", "bicha", "filho da puta",
  // Dutch
  "klootzak", "kanker", "kut", "hoer", "kankerlijer", "neuken",
  // Polish
  "kurwa", "chuj", "pierdol", "jebac", "jebać", "skurwysyn", "huj", "cipa",
  "pizda", "spierdalaj", "dupek",
  // Swedish
  "fitta", "knulla", "knull", "hora", "jävel", "kuk", "javla",
  // Danish
  "fisse", "kælling", "lort", "satan", "pikslikker", "luder",
];

// Build a single regex with word boundaries (also catch leet/spaces variants).
const escape = (s) => s.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
const PATTERN = new RegExp(
  `\\b(${BAD_WORDS_RAW.map(escape).join("|")})\\b`,
  "i"
);

export function containsBadWords(text) {
  if (!text) return false;
  // Normalise diacritics & common leetspeak (1→i, 3→e, 0→o, @→a, $→s)
  const normalised = text
    .toLowerCase()
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .replace(/[1!]/g, "i")
    .replace(/3/g, "e")
    .replace(/0/g, "o")
    .replace(/@/g, "a")
    .replace(/\$/g, "s");
  return PATTERN.test(normalised);
}

export const BAD_WORDS_COUNT = BAD_WORDS_RAW.length;
